
import { defineComponent, onMounted } from "vue";

import ListWidget5 from "@/components/widgets/lists/Widget5.vue"; 
import MixedWidget2 from "@/components/widgets/mixed/Widget2.vue"; 
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import AccountDetails from "@/components/dashboard/AccountDetails.vue"
import EstoreTrans from "@/views/EstoreTrans.vue";
import { getCurrentUser } from "@/utils/index"
import {getPCPMonitoringDetails, ignorePCPMilestone, upgradePCPAccount}  from "@/api/pcp";
import Swal from "sweetalert2/dist/sweetalert2.min.js";


    

export default defineComponent({
  name: "dashboardpcp",
  components: {
    ListWidget5,
    MixedWidget2,
    AccountDetails,
    EstoreTrans
},
  data() {
    return {
      user: {},
      currency : "",
      pt : "",
      pcpmonitoring: {},
      nextMilestone : 0.00,
      upgradeAmount : 0.00,
      upgradePackage : "",
      nextTargetPackage : "",
      dtcURL : "https://ec5.empoweredconsumerism.com/",
      ccode : -1
    }
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  }, 
  methods: {
  
    async upgradeAccountFN() {

      if(this.ccode == 0){
        this.dtcURL = "https://ec5.empoweredconsumerism.com/";
      } else {
        this.dtcURL = "https://my.economydesigner3.com/";
      }

      const response = await upgradePCPAccount(this.upgradePackage);
        if(response != null){

          if (response.data.result == "SUCCESS") {
            
            this.$router.push('/logout') ;

            Swal.fire({
            title: "Congratulations!",
            html: "You have succesfully upgraded your account to " + this.upgradePackage + " Package.<br>Please contact your direct sponsor to set-up your genealogy placement. <br> Click Proceed to login your new account to <a href='" + this.dtcURL + "'>" + this.dtcURL + "</a> using your current username and password.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Proceed",
            cancelButtonText: "Cancel"
          }).then((result) => {
            if (result.isConfirmed) {
              
              window.location.href = this.dtcURL;
            }
          });
            


          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
            }); 
          }
        }
      
    },

    async getPCPMonitoringDetailsFN(){
      const response = await getPCPMonitoringDetails();

      if(response.data != null){
        if(response.data.currency != undefined && response.data.currency != null){
          this.currency = response.data.currency;
        }
        if(response.data.pcpmonitor != undefined && response.data.pcpmonitor != null){
          this.pcpmonitoring = response.data.pcpmonitor;
          this.nextMilestone = response.data.pcpmonitor.nextMilestone;
          this.upgradeAmount = response.data.pcpmonitor.milestoneAmount;
          this.upgradePackage = response.data.pcpmonitor.unlockedUpgradePackage;
          this.nextTargetPackage = response.data.pcpmonitor.nextTargetPackage;
        }
      }
    },


    async pCPMilestoneIgnoreConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        html: "If you proceed, you will be aiming for the next milestone (" + this.nextTargetPackage + ").<br>This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel"
      }).then((result) => {
        if (result.isConfirmed) {
          this.ignorePCPMilestoneFN();
        }
      });
    },
    async pCPUpgradeConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        html: "If you proceed, your account will be upgraded to " + this.upgradePackage + " Package.<br>Do you want to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel"
      }).then((result) => {
        if (result.isConfirmed) {
          this.upgradeAccountFN();
        }
      });
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    async ignorePCPMilestoneFN(){
      const response = await ignorePCPMilestone();
        if(response != null){

          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
            }); 
            window.location.reload();
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
            }); 
          }
        }
    }

   
      


  },
  mounted(){
    
        this.getPCPMonitoringDetailsFN();
        this.user = getCurrentUser();
        this.pt = String(localStorage.getItem("pt"));
        this.ccode = Number(localStorage.getItem("ccode"));
        //this.initSlotData();
/*
        if(localStorage.getItem("pt") === 'ovi'){
          this.$router.push('/dashboard/reminderspage') ;
        } else if(localStorage.getItem("pt") === 'ecp' || localStorage.getItem("pt") === 'edp'){
          this.$router.push('/dashboardecp/reminderspage') ;
        } else if(localStorage.getItem("pt") === 'pcp' ){
          this.$router.push('/dashboardpcp') ;
        } 
         */

  },
});
